'use client';

import { useTranslations } from 'next-intl';
import { FeatureDetailContent } from './FeatureDetailContent';
import {
    Bitcoin,
    Wallet,
    Shield,
    Zap,
    Lock
} from 'lucide-react';

export function BitcoinIntegrationContent() {
    const t = useTranslations('bitcoinIntegration');

    const features = [
        {
            icon: Wallet,
            title: t('features.wallet.title'),
            description: t('features.wallet.description'),
        },
        {
            icon: Shield,
            title: t('features.automation.title'),
            description: t('features.automation.description'),
        },
        {
            icon: Lock,
            title: t('features.encryption.title'),
            description: t('features.encryption.description'),
        },
        {
            icon: Zap,
            title: t('features.apiIntegration.title'),
            description: t('features.apiIntegration.description'),
        },
    ];

    // Get benefits list from translations, ensuring it's always an array
    const benefitsRaw = t.raw('benefits.list');
    const benefits = Array.isArray(benefitsRaw) ? benefitsRaw : (benefitsRaw ? [benefitsRaw] : []);

    return (
        <FeatureDetailContent
            pageKey="bitcoin-integration"
            translationNamespace="bitcoinIntegration"
            features={features}
            benefits={benefits}
            ctaIcon={Bitcoin}
            showWhatIsBitcoin={true}
            introImageSrc="/images/features/bitcoin.webp"
            introImageAlt={t('intro.imageAlt') || 'Bitcoin Integration in MLM Software'}
            introParagraphKeys={['paragraph2', 'paragraph3']}
            introSectionHeadingPage="bitcoin-integration"
            introSectionHeadingTitle={t('intro.sectionHeadingTitle') || 'About Bitcoin Integration'}
            introSectionHeadingPill={t('intro.sectionHeadingPill') || 'Bitcoin Integration'}
            useLocaleContent={true}
        />
    );
}

